import {
  Text,
  GreyGrey60,
  IndigoIndigo60,
  Link,
  Primary13Regular,
  Primary13SemiBold,
  Flex
} from '@sequencehq/core-components'
import { useMemo } from 'react'
import { match } from 'ts-pattern'

type PriceType = 'LIST' | 'VARIANT'

type EmptyContentProps = {
  priceType: PriceType
}

export const EmptyContent = (props: EmptyContentProps) => {
  const title = useMemo(() => {
    return match(props.priceType)
      .with('LIST', () => 'No list prices')
      .with('VARIANT', () => 'No price variants')
      .exhaustive()
  }, [props.priceType])

  const description = useMemo(() => {
    return match(props.priceType)
      .with(
        'LIST',
        () =>
          'List prices will appear here once you create them for this product.'
      )
      .with(
        'VARIANT',
        () =>
          'Prices from billing schedules will appear here once you create a billing schedule and add prices.'
      )
      .exhaustive()
  }, [props.priceType])

  return (
    <Flex width="full" placeContent="center" py={4}>
      <Flex
        width="265px"
        whiteSpace="pre-line"
        flexDirection="column"
        textAlign="center"
        gap={1}
      >
        <Text {...Primary13SemiBold}>{title}</Text>
        <Text {...Primary13Regular} color={GreyGrey60}>
          {description}{' '}
          <Link.Unstyled
            style={{ display: 'inline', color: IndigoIndigo60 }}
            to="https://docs.sequencehq.com/plans-products/product-catalogue"
            target="_blank"
          >
            {' '}
            Learn more
          </Link.Unstyled>
        </Text>
      </Flex>
    </Flex>
  )
}
